// @flow

import { type IncomingPayment } from './types';

export function getPaymentType(incomingPayment: IncomingPayment): ?string {
  return incomingPayment['payment_type'];
}

export function getSafePaymentType(incomingPayment: IncomingPayment): string {
  const paymentType = getPaymentType(incomingPayment);

  if (!paymentType)
    throw new Error('getPaymentType - there is no payment type in incoming payment');

  return paymentType;
}
